/**
 * Suivi de progression des mini-quiz complétés — 100% localStorage (no backend).
 *
 * Stockage :
 *   - localStorage key : "mq_progress_v1"
 *   - format : {
 *       completed: string[],           // liste des testIdRoot complétés (déduplicated)
 *       lastActiveDay: "YYYY-MM-DD",   // dernier jour où l'utilisateur a fait au moins 1 quiz
 *       streak: number,                // jours consécutifs actifs
 *     }
 *
 * Total de mini-quiz du site :
 *   - 10 AD thématiques + 20 AD Paris + 10 PE thématiques + 20 PE Paris = 60
 */
export const TOTAL_MINI_QUIZ = 60;

const KEY = 'mq_progress_v1';

function readState() {
  if (typeof window === 'undefined') return { completed: [], lastActiveDay: null, streak: 0 };
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { completed: [], lastActiveDay: null, streak: 0 };
    const s = JSON.parse(raw);
    return {
      completed: Array.isArray(s.completed) ? s.completed : [],
      lastActiveDay: s.lastActiveDay || null,
      streak: Number.isFinite(s.streak) ? s.streak : 0,
    };
  } catch { return { completed: [], lastActiveDay: null, streak: 0 }; }
}

function writeState(s) {
  try { localStorage.setItem(KEY, JSON.stringify(s)); } catch { /* quota */ }
}

function todayISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function daysBetween(aISO, bISO) {
  const a = new Date(aISO + 'T00:00:00');
  const b = new Date(bISO + 'T00:00:00');
  return Math.round((b - a) / 86400000);
}

/**
 * Marque un mini-quiz comme complété (déduplication automatique).
 * Met à jour aussi le streak (jours consécutifs).
 */
export function markMiniQuizComplete(testIdRoot) {
  if (!testIdRoot) return;
  const s = readState();
  if (!s.completed.includes(testIdRoot)) s.completed.push(testIdRoot);
  const today = todayISO();
  if (s.lastActiveDay) {
    const diff = daysBetween(s.lastActiveDay, today);
    if (diff === 0) { /* même jour, streak inchangé */ }
    else if (diff === 1) { s.streak = (s.streak || 0) + 1; }
    else { s.streak = 1; }
  } else {
    s.streak = 1;
  }
  s.lastActiveDay = today;
  writeState(s);
  // Dispatch un CustomEvent pour que les composants abonnés se rafraîchissent
  try { window.dispatchEvent(new CustomEvent('mq-progress-update', { detail: s })); } catch { /* SSR */ }
}

export function getProgress() {
  return readState();
}

/**
 * Badges paliers — inspirés de gamification classique.
 * On les débloque en fonction du nombre de mini-quiz complétés.
 */
export const MILESTONES = [
  { threshold: 3,  emoji: '🌱', label: 'Premier envol', code: 'seed' },
  { threshold: 10, emoji: '🃏', label: 'Curieux', code: 'curious' },
  { threshold: 30, emoji: '🎓', label: 'Explorateur', code: 'explorer' },
  { threshold: 60, emoji: '👑', label: 'Maître des 60', code: 'master' },
];

export function currentMilestone(count) {
  return [...MILESTONES].reverse().find((m) => count >= m.threshold) || null;
}

export function nextMilestone(count) {
  return MILESTONES.find((m) => count < m.threshold) || null;
}
